"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Set status of orderItem and the order to REFUNDED
 * @param event
 * @param prevState
 */
function default_1(event, prevState) {
    const order = (0, utils_1.clone)(prevState);
    const itemIds = event.orderItems.map(item => item.id);
    order.orderItems = order.orderItems.filter(orderItem => {
        return itemIds.includes(orderItem.id);
    });
    event.orderItems.forEach(orderItem => {
        const itemIndex = order.orderItems.findIndex(item => item.id === orderItem.id);
        order.orderItems[itemIndex] = {
            ...order.orderItems[itemIndex],
            quantity: orderItem.quantity,
        };
    });
    order.orderItems.every(orderItem => (orderItem.status = domain_1.OrderItemStatus.REFUNDED));
    // Skip payment surcharge and converting order adjustments from flat to percentage.
    order.adjustments = (order.adjustments || [])
        .filter(adjustment => !adjustment.allowOnPaymentType)
        .map(adjustment => (0, computePrice_1.flatToPercentageForAdjustment)(adjustment, order.subTotal));
    // In case of partial refund order total should exclude these below fields.
    // deliveryFee, serviceCharge and tip.
    order.deliveryFee = 0;
    order.serviceCharge = 0;
    order.tip = 0;
    order.refundType = domain_1.RefundType.By_PRODUCT;
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
        roundingAmount: 0,
    };
}
exports.default = default_1;
//# sourceMappingURL=refundOrderItems.js.map